module.exports = __webpack_public_path__ + "static/media/mi3.00f2df52.jpg";